(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cp-laces-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-laces-variant-picker')) {
    customElements.define('cp-laces-variant-picker', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.abort = new AbortController();
        this.variants = JSON.parse(this.querySelector('[data-laces-variants]').textContent);
        this.colourIndex = Number(this.dataset.colourIndex);
        this.variantSelect = this.closest('form')?.querySelector('select[name="id"]');
        this.groups = Array.from(this.querySelectorAll('[data-laces-option]'));
        this.optionOrder = this.groups.map((group, index) => JSON.parse(group.dataset.lacesOrder)
          .map(value => index === this.colourIndex ? value.replace(/ (UPC|EAN)$/i, '') : value));
        this.current = this.variants.find(variant => variant.id === this.variantSelect?.value)
          || this.variants.find(variant => variant.id === this.dataset.selectedId) || this.variants[0];
        if (!this.variantSelect || !this.current) return;
        this.observer = new MutationObserver(() => {
          this.groups.forEach(group => {
            const trigger = group.querySelector('[data-laces-trigger]');
            trigger.setAttribute('aria-expanded', String(trigger.classList.contains('is--clicked')));
          });
        });
        this.groups.forEach(group => {
          const trigger = group.querySelector('[data-laces-trigger]');
          this.observer.observe(trigger, { attributes: true, attributeFilter: ['class'] });
          trigger.addEventListener('click', () => {
            queueMicrotask(() => {
              if (trigger.classList.contains('is--clicked')) {
                group.querySelector('[data-laces-choice][aria-pressed="true"]')?.focus();
              }
            });
          }, { signal: this.abort.signal });
          group.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              group.querySelector('[data-dropdown-close]').click();
              trigger.focus();
            }
            if (!event.target.matches('[data-laces-choice]')) return;
            const buttons = Array.from(group.querySelectorAll('[data-laces-choice]'));
            const index = buttons.indexOf(event.target);
            const target = { ArrowDown: (index + 1) % buttons.length, ArrowUp: (index + buttons.length - 1) % buttons.length, Home: 0, End: buttons.length - 1 }[event.key];
            if (target !== undefined) {
              event.preventDefault();
              buttons[target].focus();
            }
          }, { signal: this.abort.signal });
        });
        this.refresh();
      }
      choices(index) {
        // Keep every stocked colour reachable; preserve the other option when possible.
        const candidates = this.variants.filter(variant => index === this.colourIndex || this.colourIndex < 0 || variant.key[this.colourIndex] === this.current.key[this.colourIndex]);
        const score = variant => variant.key.reduce((total, value, position) => total + Number(position !== index && value === this.current.key[position]), 0);
        const choices = new Map();
        candidates.forEach(variant => {
          const key = variant.key[index];
          if (!choices.has(key) || score(variant) > score(choices.get(key))) choices.set(key, variant);
        });
        return Array.from(choices.values()).sort((a, b) => this.optionOrder[index].indexOf(a.key[index]) - this.optionOrder[index].indexOf(b.key[index]));
      }
      refresh() {
        this.groups.forEach(group => {
          const index = Number(group.dataset.lacesOption);
          group.querySelectorAll('[data-laces-current]').forEach(label => { label.textContent = this.current.key[index]; });
          group.querySelector('[data-laces-trigger]').disabled = false;
          const buttons = this.choices(index).map(variant => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 't4s-swatch__item t4s-truncate';
            button.setAttribute('data-laces-choice', '');
            button.setAttribute('data-dropdown-off', '');
            button.dataset.lacesValue = variant.key[index];
            button.setAttribute('aria-pressed', String(variant.key[index] === this.current.key[index]));
            button.textContent = variant.key[index];
            button.addEventListener('click', () => {
              group.querySelector('[data-dropdown-close]').click();
              this.choose(index, variant.key[index]);
              group.querySelector('[data-laces-trigger]').focus({ preventScroll: true });
            });
            return button;
          });
          group.querySelector('[data-laces-choices]').replaceChildren(...buttons);
        });
      }
      choose(index, value) {
        const winner = this.choices(index).find(variant => variant.key[index] === value);
        if (!winner || !Array.from(this.variantSelect.options).some(option => option.value === winner.id && !option.disabled)) return;
        this.current = winner;
        this.refresh();
        this.variantSelect.value = winner.id;
        this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-product-option-tiles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-two-variant-picker')) {
    customElements.define('cp-two-variant-picker', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const controller = this.abort;
        queueMicrotask(() => {
          if (!this.isConnected || this.abort !== controller) return;
          this.variantSelect = document.getElementById(this.dataset.formId)?.querySelector('select[name="id"]');
          this.radios = Array.from(this.querySelectorAll('[data-two-variant-choice]'));
          this.variants = JSON.parse(this.querySelector('[data-two-variant-data]').textContent);
          if (!this.variantSelect) return;
          const signal = controller.signal;
          this.addEventListener('change', event => {
            if (event.target.matches('[data-two-variant-choice]')) this.choose(event.target);
          }, { signal });
          this.addEventListener('keydown', event => {
            if (!event.target.matches('[data-two-variant-choice]')) return;
            const available = this.radios.filter(radio => !radio.disabled);
            const index = available.indexOf(event.target);
            const next = {
              ArrowRight: (index + 1) % available.length,
              ArrowDown: (index + 1) % available.length,
              ArrowLeft: (index + available.length - 1) % available.length,
              ArrowUp: (index + available.length - 1) % available.length,
              Home: 0,
              End: available.length - 1
            }[event.key];
            if (next === undefined || !available[next]) return;
            event.preventDefault();
            available[next].focus();
            this.choose(available[next]);
          }, { signal });
          this.variantSelect.addEventListener('change', () => this.sync(), { signal });
          this.addToCart = document.getElementById(this.dataset.formId)?.querySelector('[data-atc-form]');
          if (this.addToCart && window.ResizeObserver) {
            this.widthObserver = new ResizeObserver(() => this.syncWidth());
            this.widthObserver.observe(this.addToCart);
          }
          window.addEventListener('resize', () => this.syncWidth(), { signal });
          this.syncWidth();
          this.sync();
        });
      }
      choose(radio) {
        const option = Array.from(this.variantSelect.options).find(option => option.value === radio.value);
        if (radio.disabled || !option || option.disabled) {
          this.sync();
          return;
        }
        if (this.variantSelect.value !== radio.value) {
          this.variantSelect.value = radio.value;
          this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.sync();
      }
      sync() {
        const variant = this.variants.find(variant => variant.id === this.variantSelect.value);
        this.radios.forEach(radio => { radio.checked = !!variant && radio.dataset.optionValue === variant.value; });
      }
      syncWidth() {
        const width = this.addToCart?.getBoundingClientRect().width;
        if (width) this.style.setProperty('--cp-two-picker-width', `${width}px`);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.widthObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-spray-bundle-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-spray-bundles')) {
  customElements.define('cp-spray-bundles', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.originals = new Map();
      this.start = () => this.initialize();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.start, { once: true, signal: this.abort.signal });
      } else {
        queueMicrotask(this.start);
      }
    }

    initialize() {
      if (!this.isConnected || this.initialized) return;
      this.form = document.getElementById(this.dataset.formId);
      this.section = this.closest('.shopify-section');
      this.select = this.querySelector('[data-bundle-select]');
      this.idField = this.form?.querySelector('input[name="id"]');
      if (!this.form || !this.section || !this.select || !this.idField) return;
      this.initialized = true;
      this.select.value = 'single';
      this.selectedValue = 'single';
      this.select.disabled = false;
      this.select.addEventListener('change', () => this.changePack(), { signal: this.abort.signal });
      this.selectedDisplay = this.querySelector('[data-bundle-selected]');
      this.selectedBadge = this.querySelector('[data-bundle-selected-badge]');
      this.syncDisplay();
      this.onCart = (event) => {
        if (!this.active) return;
        const button = event.target.closest?.('[data-atc-form], [data-action-atc]');
        const sticky = this.sticky();
        const isMain = event.type === 'submit' ? event.target === this.form : button && this.form.contains(button);
        const isSticky = button && sticky?.contains(button);
        if (!isMain && !isSticky) return;
        if (this.isAdding() || !this.option() || this.option().disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        this.syncPurchaseFields(false);
      };
      document.addEventListener('click', this.onCart, { capture: true, signal: this.abort.signal });
      document.addEventListener('submit', this.onCart, { capture: true, signal: this.abort.signal });
      this.observer = new MutationObserver((records) => {
        if (!this.active) return;
        const addedSticky = records.some((record) => Array.from(record.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches('[data-sticky-addtocart]') || node.querySelector('[data-sticky-addtocart]'))
        ));
        if (addedSticky) this.syncSticky(false);
      });
    }

    option() {
      return this.select.selectedOptions[0];
    }

    syncDisplay() {
      if (!this.selectedDisplay) return;
      const template = this.querySelector(`template[data-bundle-template="${this.select.value}"]`)?.content;
      const details = template?.querySelector('[data-bundle-display]');
      if (details) this.selectedDisplay.innerHTML = details.innerHTML;
      if (this.selectedBadge) {
        const badge = template?.querySelector('[data-bundle-badge]')?.textContent.trim() || '';
        this.selectedBadge.textContent = badge;
        this.selectedBadge.hidden = !badge;
      }
    }

    sticky() {
      return document.querySelector('[data-sticky-addtocart]');
    }

    isAdding() {
      return this.form.querySelector('[data-atc-form].is--loading') || this.sticky()?.querySelector('[data-action-atc].is--loading');
    }

    remember(element) {
      if (!this.originals.has(element)) this.originals.set(element, { attributes: {} });
      return this.originals.get(element);
    }

    attribute(element, name, value) {
      const state = this.remember(element);
      if (!(name in state.attributes)) state.attributes[name] = element.getAttribute(name);
      if (value === null || value === '') element.removeAttribute(name);
      else element.setAttribute(name, value);
    }

    value(element, value) {
      const state = this.remember(element);
      if (!('value' in state)) state.value = element.value;
      element.value = String(value);
    }

    html(element, html) {
      const state = this.remember(element);
      if (!('html' in state)) state.html = element.innerHTML;
      element.innerHTML = html;
    }

    quantity(input, reset) {
      const option = this.option();
      const min = Math.max(1, Number(option.dataset.min) || 1);
      const step = Math.max(1, Number(option.dataset.step) || 1);
      const max = option.dataset.max ? Number(option.dataset.max) : Infinity;
      this.attribute(input, 'min', String(min));
      this.attribute(input, 'step', String(step));
      this.attribute(input, 'max', Number.isFinite(max) ? String(max) : null);
      let quantity = reset ? min : Number(input.value);
      if (!Number.isFinite(quantity)) quantity = min;
      quantity = Math.max(min, Math.min(quantity, max));
      this.value(input, min + Math.floor((quantity - min) / step) * step);
    }

    syncPurchaseFields(reset) {
      this.value(this.idField, this.option().dataset.variantId);
      this.form.querySelectorAll('[name="quantity"]').forEach((input) => this.quantity(input, reset));
      const sticky = this.sticky();
      if (sticky) {
        sticky.querySelectorAll('[data-action-atc]').forEach((button) =>
          this.attribute(button, 'data-variant-id', this.option().dataset.variantId)
        );
        sticky.querySelectorAll('[name="quantity"]').forEach((input) => this.quantity(input, reset));
      }
    }

    priceHtml() {
      return this.querySelector(`template[data-bundle-template="${this.select.value}"]`).content.querySelector('[data-bundle-price]').innerHTML;
    }

    updateButtons(container, selector) {
      const label = (this.dataset.bundleAtc || '').replace('[pack]', this.option().dataset.packLabel);
      container.querySelectorAll(selector).forEach((button) => {
        this.attribute(button, 'disabled', null);
        this.attribute(button, 'aria-disabled', null);
        button.querySelectorAll('.t4s-btn-atc_text').forEach((text) => {
          this.remember(text);
          if (!('html' in this.originals.get(text))) this.originals.get(text).html = text.innerHTML;
          text.textContent = label;
        });
      });
    }

    syncSticky(reset) {
      const sticky = this.sticky();
      if (!sticky) return;
      sticky.classList.add('cp-spray-bundle-active');
      sticky.querySelectorAll('[data-sticky-price]').forEach((price) => this.html(price, this.priceHtml()));
      sticky.querySelectorAll('.t4s-sticky-atc__title').forEach((title) => {
        const bundleTitle = this.querySelector(`template[data-bundle-template="${this.select.value}"]`).content.querySelector('[data-bundle-title]');
        if (bundleTitle) {
          const state = this.remember(title);
          if (!('html' in state)) state.html = title.innerHTML;
          title.textContent = bundleTitle.textContent;
        }
      });
      this.updateButtons(sticky, '[data-action-atc]');
      this.syncPurchaseFields(reset);
    }

    changePack() {
      if (this.isAdding()) {
        this.select.value = this.selectedValue;
        this.syncDisplay();
        return;
      }
      let option = this.option();
      if (!option || option.disabled) {
        this.select.value = 'single';
        option = this.option();
      }
      const template = this.querySelector(`template[data-bundle-template="${this.select.value}"]`);
      if (!template) return;
      this.selectedValue = this.select.value;
      this.syncDisplay();
      if (this.select.value === 'single') {
        this.restore();
        return;
      }
      this.active = true;
      this.section.classList.add('cp-spray-bundle-active');
      this.section.querySelectorAll('[data-product-price]').forEach((price) => this.html(price, this.priceHtml()));
      this.updateButtons(this.form, '[data-atc-form]');
      this.syncPurchaseFields(true);
      this.syncSticky(true);
      this.observer.observe(document.body, { childList: true, subtree: true });
    }

    restore() {
      this.active = false;
      this.observer?.disconnect();
      this.section?.classList.remove('cp-spray-bundle-active');
      this.sticky()?.classList.remove('cp-spray-bundle-active');
      this.originals.forEach((state, element) => {
        Object.entries(state.attributes).forEach(([name, value]) => {
          if (value === null) element.removeAttribute(name);
          else element.setAttribute(name, value);
        });
        if ('value' in state) element.value = state.value;
        if ('html' in state) element.innerHTML = state.html;
      });
      this.originals.clear();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.restore();
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-three-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-three-variant-picker')) {
    customElements.define('cp-three-variant-picker', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.abort = new AbortController();
        this.variants = JSON.parse(this.querySelector('[data-three-variants]').textContent);
        this.variantSelect = document.getElementById(this.dataset.formId)?.querySelector('select[name="id"]');
        this.groups = Array.from(this.querySelectorAll('[data-three-option]'));
        this.optionOrder = this.groups.map(group => JSON.parse(group.dataset.threeOrder));
        this.current = this.variants.find(variant => String(variant.id) === String(this.variantSelect?.value))
          || this.variants.find(variant => String(variant.id) === this.dataset.selectedId) || this.variants[0];
        if (!this.variantSelect || !this.current) return;
        const signal = this.abort.signal;
        this.observer = new MutationObserver(() => this.groups.forEach(group => {
          const trigger = group.querySelector('[data-three-trigger]');
          trigger?.setAttribute('aria-expanded', String(trigger.classList.contains('is--clicked')));
        }));
        this.groups.forEach(group => {
          const trigger = group.querySelector('[data-three-trigger]');
          if (trigger) this.observer.observe(trigger, { attributes: true, attributeFilter: ['class'] });
          trigger?.addEventListener('click', () => queueMicrotask(() => group.querySelector('[data-three-choice][aria-pressed="true"]')?.focus()), { signal });
          group.addEventListener('keydown', event => {
            if (event.key === 'Escape') { group.querySelector('[data-dropdown-close]')?.click(); trigger?.focus(); }
            if (!event.target.matches('[data-three-choice]')) return;
            const buttons = Array.from(group.querySelectorAll('[data-three-choice]:not(:disabled)'));
            const index = buttons.indexOf(event.target);
            const target = { ArrowDown: (index + 1) % buttons.length, ArrowUp: (index + buttons.length - 1) % buttons.length, Home: 0, End: buttons.length - 1 }[event.key];
            if (target !== undefined && buttons[target]) { event.preventDefault(); buttons[target].focus(); }
          }, { signal });
        });
        this.variantSelect.addEventListener('change', () => {
          const variant = this.variants.find(item => String(item.id) === String(this.variantSelect.value));
          if (variant) { this.current = variant; this.refresh(); }
        }, { signal });
        this.addToCart = document.getElementById(this.dataset.formId)?.querySelector('[data-atc-form]');
        if (this.addToCart && window.ResizeObserver) { this.widthObserver = new ResizeObserver(() => this.syncWidth()); this.widthObserver.observe(this.addToCart); }
        window.addEventListener('resize', () => this.syncWidth(), { signal });
        this.syncWidth();
        this.refresh();
      }
      candidate(index, value) {
        let candidates = this.variants.filter(variant => variant.key[index] === value);
        if (index > 0) candidates = candidates.filter(variant => variant.key.slice(0, index).every((entry, position) => entry === this.current.key[position]));
        return candidates.find(variant => variant.key.every((entry, position) => position === index || entry === this.current.key[position])) || candidates[0];
      }
      refresh() {
        this.groups.forEach(group => {
          const index = Number(group.dataset.threeOption);
          const mode = group.dataset.threeMode;
          group.querySelectorAll('[data-three-current]').forEach(label => { label.textContent = this.current.key[index]; });
          const trigger = group.querySelector('[data-three-trigger]');
          if (trigger) trigger.disabled = false;
          const buttons = this.optionOrder[index].map(value => {
            const variant = this.candidate(index, value);
            const option = variant && Array.from(this.variantSelect.options).find(item => String(item.value) === String(variant.id));
            const button = document.createElement('button');
            button.type = 'button';
            button.className = mode === 'swatch' ? 'cp-three__swatch' : 't4s-swatch__item t4s-truncate';
            button.setAttribute('data-three-choice', '');
            if (mode === 'dropdown') button.setAttribute('data-dropdown-off', '');
            button.dataset.threeValue = value; button.disabled = !variant || !option || option.disabled;
            button.setAttribute('aria-pressed', String(value === this.current.key[index]));
            if (mode === 'swatch') {
              button.setAttribute('aria-label', value);
              const swatchTemplate = group.querySelector('template[data-three-swatches]');
              const swatch = Array.from(swatchTemplate?.content.querySelectorAll('[data-three-swatch]') || []).find(item => item.dataset.threeSwatch === value)?.firstElementChild;
              if (swatch) button.append(swatch.cloneNode(true));
              const name = document.createElement('span'); name.className = 'cp-three__swatch-name'; name.setAttribute('aria-hidden', 'true'); name.textContent = value; button.append(name);
            } else if (mode === 'segmented') {
              const icon = document.createElement('span');
              const valueHandle = value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
              icon.className = `cp-card-options__type-icon cp-card-options__type-icon--${valueHandle}`; icon.setAttribute('aria-hidden', 'true');
              button.append(icon, value);
            } else button.textContent = value;
            button.addEventListener('click', () => { group.querySelector('[data-dropdown-close]')?.click(); this.choose(index, value); group.querySelector('[data-three-trigger]')?.focus({ preventScroll: true }); });
            return button;
          });
          group.querySelector('[data-three-choices]').replaceChildren(...buttons);
        });
      }
      choose(index, value) {
        const winner = this.candidate(index, value);
        const option = winner && Array.from(this.variantSelect.options).find(item => String(item.value) === String(winner.id));
        if (!winner || !option || option.disabled) return;
        this.current = winner; this.refresh(); this.variantSelect.value = winner.id;
        this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncWidth() { const width = this.addToCart?.getBoundingClientRect().width; if (width) this.style.setProperty('--cp-three-picker-width', `${width}px`); }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.widthObserver?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
